import { render, staticRenderFns } from "./address-nav.vue?vue&type=template&id=4ce88ec3&scoped=true"
import script from "./address-nav.vue?vue&type=script&lang=js"
export * from "./address-nav.vue?vue&type=script&lang=js"
import style0 from "./address-nav.vue?vue&type=style&index=0&id=4ce88ec3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce88ec3",
  null
  
)

export default component.exports